import styled, { css } from 'styled-components';
import { LocalizedButton } from 'shared/ui/localized-button';

export const StyledCreateAccountButton = styled(LocalizedButton)<{ isResizeButton?: boolean }>`
    text-transform: uppercase;

    @media (max-width: 768px) {
        ${({ isResizeButton }) =>
            isResizeButton &&
            css`
                width: 100%;
            `};
    }
`;
